export const parseRoomSelection = (
  selectedRoomIds: string[],
  categoryRooms: string[]
): { normalRooms: string[]; hasFivePlus: boolean } => {
  const roomsSet = new Set(selectedRoomIds);

  return categoryRooms.reduce(
    (acc, id) => {
      if (roomsSet.has(id)) {
        if (id === '5+') acc.hasFivePlus = true;
        else acc.normalRooms.push(id);
      }
      return acc;
    },
    { normalRooms: [] as string[], hasFivePlus: false }
  );
};
